import React, { Component } from "react";
import { Form, Button, Icon } from "antd";
import { Redirect } from "react-router-dom";
import "./LoginPage.css";
import {
  validateSenha,
  checkFormIsValid
} from "../utils/Validator";
import InputForm from "../components/InputForm";
import axios from "axios";
import { saveToken, isLoggedIn } from '../utils/LoginManager';

const ItemForm = Form.Item;

export default class LoginPage extends Component {
  state = {
    email: "",
    senha: "",
    aguarde: false
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    this.setState({
      [id]: value
    });
  };

  onLogin = event => {
    event.preventDefault();

    const formValid = checkFormIsValid(this.refs);
    if (formValid) {
      const { usuario, senha } = this.state;

      const body = {
        usuario,
        senha
      };

      this.setState({
        aguarde: true
      });

//      const request = axios.post("http://gerenciadordetarefas.local/api/usuarios/login", body);
      const request = axios.post("/usuarios/login", body);

      request.then(response => {
        console.error(response);
        this.setState({
          aguarde: false
        });
        saveToken(response.data.token); // grava o token no cookies
        this.props.history.push('/'); // vai para a página inicial
      });

      request.catch(error => {
        console.error(error);
        this.setState({
          aguarde: false
        });
        if (error.response) {
          if (error.response.status === 401) {
            alert("Usuário ou Senha Incorreto");
          } else {
            alert("Entre em contato com o suporte do sistema.");
          }
        } else {
          alert(
            "Não foi possível se comunicar com o servidor, verifique sua internet."
          );
        }
      });
    }
  };

  render() {
    if (isLoggedIn()) {
      return(
        <Redirect to="/"/>
      )
    }

    //    const email = this.state.email;
    //    const senha = this.state.senha;
    const { usuario, senha, aguarde } = this.state;

    return (
      <Form className="login-form" onSubmit={this.onLogin}>
        <ItemForm>
          <h2>Entre com os dados do Usuário</h2>
        </ItemForm>

        <InputForm
          type="text"
          id="usuario"
          ref="usuario"
          title="Digite o Usuário"
          placeholder="Usuário"
          prefix={<Icon type="user" />}
          size="large"
          maxLength={150}
          required
          validator={text => Boolean(text)} // verifica se o campo está vazio ou válido
          value={usuario}
          onChange={this.onChange}
          errorMessage="Usuário Inválido"
        />

        <InputForm
          type="password"
          id="senha"
          ref="senha"
          title="Digite a Senha"
          placeholder="Senha"
          prefix={<Icon type="lock" />}
          size="large"
          maxLength={150}
          required
          validator={validateSenha}
          value={senha}
          onChange={this.onChange}
          errorMessage="Senha Inválida"
        />
        <ItemForm>
          <Button
            type="primary"
            htmlType="submit"
            className="login-botao"
            size="large"
            loading={aguarde}
          >
            Entrar
          </Button>
        </ItemForm>
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LoginPage.js